import { render, staticRenderFns } from "./edit-data.vue?vue&type=template&id=76d7c17e"
import script from "./edit-data.vue?vue&type=script&lang=js"
export * from "./edit-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports